<template>
  <i class="iconfont" :class="[isFullscreen?'icon-minimize':'icon-maximize']" style="display: block;"
    @click="onScreenFullClick"></i>
</template>

<script>
import screenfull from "screenfull";

export default {
  data() {
    return {
      isFullscreen: false,
    }
  },
  methods: {
    init() {
      if (screenfull.enabled) {
        screenfull.on('change', this.change);
      }
    },
    destroy() {
      if (screenfull.enabled) {
        screenfull.off('change', this.change);
      }
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen;
    },
    onScreenFullClick() {
      if (!screenfull.enabled) {
        this.$message({
          message: "您的浏览器不支持全屏!!!",
          type: "warning"
        });
        return false;
      }
      screenfull.toggle();
    },
    checkFull() {
      var isFull = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },
    handleKeyDown(event) {
      var key = window.event.keyCode ? window.event.keyCode : window.event.which;
      if (key == 122) {
        event.returnValue = false;
        this.onScreenFullClick();
      }
    },
  },
  mounted() {
    this.init();
    document.addEventListener('keydown', this.handleKeyDown);
  },
  unmounted() {
    this.destroy();
  },
}
</script>

<style scoped>
</style>
